import authAxios from "../../axios-auth";
import globalAxios from "axios";
import router from "../../router";

const state = {
  idToken: null,
  userId: null,
  user: null,
  authError: null
};

const mutations = {
  authUser(state, userData) {
    state.idToken = userData.token;
    state.userId = userData.userId;
  },
  storeUser(state, user) {
    state.user = user;
  },
  clearAuthData(state) {
    state.idToken = null;
    state.userId = null;
    state.user = null;
  }
};

const actions = {
  setLogoutTimer({ commit }, expirationTime) {
    setTimeout(() => {
      commit("clearAuthData");
    }, expirationTime * 1000);
  },
  signup({ commit, dispatch }, authData) {
    authAxios
      .post("/signupNewUser?key=AIzaSyBDyf4nsj70k7xHLcr9JZ7k4BJSR-3HLh4", {
        email: authData.email,
        password: authData.password,
        returnSecureToken: true
      })
      .then(res => {
        // console.log(res);
        commit("authUser", {
          token: res.data.idToken,
          userId: res.data.localId
        });
        const now = new Date();
        const expirationDate = new Date(
          now.getTime() + res.data.expiresIn * 1000
        );
        localStorage.setItem("token", res.data.idToken);
        localStorage.setItem("userId", res.data.localId);
        localStorage.setItem("email", authData.email);

        localStorage.setItem("expirationDate", expirationDate);
        state.authError = null;

        dispatch("storeUser", authData);
        dispatch("setLogoutTimer", res.data.expiresIn);
        router.replace("/");
      })
      .catch(error => {
        // console.log(error);
        state.authError = error;
      });
  },
  login({ commit, dispatch }, authData) {
    authAxios
      .post("/verifyPassword?key=AIzaSyBDyf4nsj70k7xHLcr9JZ7k4BJSR-3HLh4", {
        email: authData.email,
        password: authData.password,
        returnSecureToken: true
      })
      .then(res => {
        // console.log(res);
        const now = new Date();
        const expirationDate = new Date(
          now.getTime() + res.data.expiresIn * 1000
        );
        localStorage.setItem("token", res.data.idToken);
        localStorage.setItem("userId", res.data.localId);
        localStorage.setItem("email", authData.email);
        localStorage.setItem("expirationDate", expirationDate);
        state.authError = null;

        commit("authUser", {
          token: res.data.idToken,
          userId: res.data.localId
        });
        dispatch("setLogoutTimer", res.data.expiresIn);
        dispatch("fetchUser");
        router.replace("/");
      })
      .catch(error => {
        // console.log("chad:" + error);
        state.authError = error;
      });
    // router.replace("/");
  },
  tryAutoLogin({ commit, dispatch }) {
    const token = localStorage.getItem("token");
    if (!token) {
      return;
    }
    const expirationDate = localStorage.getItem("expirationDate");
    const now = new Date();
    if (now >= expirationDate) {
      return;
    }
    const userId = localStorage.getItem("userId");
    commit("authUser", {
      token: token,
      userId: userId
    });
    dispatch("fetchUser");
  },
  logout({ commit }) {
    commit("clearAuthData");
    localStorage.removeItem("expirationDate");
    localStorage.removeItem("token");
    localStorage.removeItem("userId");

    router.replace("/signin");
  },
  //  storeUser({ commit, state }, userData) {
  storeUser({ state }, userData) {
    if (!state.idToken) {
      return;
    }
    globalAxios.post("/users.json" + "?auth=" + state.idToken, userData);
    // .then(res => console.log(res))
    // .catch(error => console.log(error));
  },
  fetchUser({ commit, state }) {
    if (!state.idToken) {
      return;
    }
    globalAxios
      .get(
        "/users.json" +
          "?auth=" +
          state.idToken +
          '&orderBy="email"&equalTo="' +
          localStorage.getItem("email") +
          '"'
      )
      .then(res => {
        // console.log(res);
        const data = res.data;
        const users = [];
        for (let key in data) {
          const user = data[key];
          user.id = key;
          users.push(user);
        }
        // console.log(users);
        commit("storeUser", users[0]);
      });
    // .catch(error => console.log(error));
  }
};

const getters = {
  user(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.idToken !== null;
  },
  authError(state) {
    return state.authError !== null;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
